import { LEVEL_THEMES } from "../../helpers/consts";

export default function EditMapTheme({ level }) {
  return (
    <button
      className="secondary-ui-button"
      onClick={() => {
        const allThemes = Object.values(LEVEL_THEMES);
        const currentIndex =
          allThemes.findIndex((theme) => theme === level.theme) ?? 0;
        const nextIndex = currentIndex + 1;
        level.editor.updateTheme(allThemes[nextIndex] ?? allThemes[0]);
      }}
    >
      Change Theme
    </button>
  );
}
